import { render, staticRenderFns } from "./ot-contracts-layout.vue?vue&type=template&id=2e34945d&scoped=true&"
import script from "./ot-contracts-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-contracts-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contracts-layout.vue?vue&type=style&index=0&id=2e34945d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34945d",
  null
  
)

export default component.exports